import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// আপনার Firebase config এখানে দিন
const firebaseConfig = {
  apiKey: "AIzaSyDYVHXyVgy7IcV9E1Y1gmrMZUN_V3WlXlE",
  authDomain: "how-tech-com-bd-7e729.firebaseapp.com",
  databaseURL: "https://how-tech-com-bd-7e729-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "how-tech-com-bd-7e729",
  storageBucket: "how-tech-com-bd-7e729.firebasestorage.app",
  messagingSenderId: "8761597972",
  appId: "1:8761597972:web:5275bdb8b52576bac38701",
  measurementId: "G-ZNW1887DT5"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);